/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SvgInfoAdminDto } from '../../models/svg-info-admin-dto';

export interface GetSvgInfoAdmin$Params {
  id: number;
}

export function getSvgInfoAdmin(http: HttpClient, rootUrl: string, params: GetSvgInfoAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<SvgInfoAdminDto>> {
  const rb = new RequestBuilder(rootUrl, getSvgInfoAdmin.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SvgInfoAdminDto>;
    })
  );
}

getSvgInfoAdmin.PATH = '/svg-info-admin/{id}';
